import { render, staticRenderFns } from "./mallGoods.vue?vue&type=template&id=be23f62c&scoped=true"
import script from "./mallGoods.vue?vue&type=script&lang=js"
export * from "./mallGoods.vue?vue&type=script&lang=js"
import style0 from "./mallGoods.vue?vue&type=style&index=0&id=be23f62c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be23f62c",
  null
  
)

export default component.exports